$( () => {
    const playersBg = Plyr.setup('.js-bg-player', {
        controls: [], // hide UI
        muted: true,
        autoplay: false
    });

    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.6 // Adjust how much of the element is visible before playing
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const video = entry.target;
            const player = playersBg.find(p => p.media === video);

            if (entry.isIntersecting) {
                player.play();
            } else {
                player.pause();
            }
        });
    }, observerOptions);

    document.querySelectorAll('.js-bg-player').forEach(video => {
        observer.observe(video);
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/video-overlay.js